var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"rules":_vm.config.rules,"label":_vm.config.label,"data-cy":_vm.config.dataCy,"dense":""},model:{value:(_vm.inputVal[_vm.config.vModel]),callback:function ($$v) {_vm.$set(_vm.inputVal, _vm.config.vModel, $$v)},expression:"inputVal[config.vModel]"}})
}
var staticRenderFns = []

export { render, staticRenderFns }